import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Tag, Row, Col, Typography, Divider } from 'antd';
import {UserContext} from "../../../common/UserContext";

const { Text } = Typography;

const TestHeader = ({ test, testResult, printButton, backButton }) => {
    const { user } = useContext(UserContext);

    const formatTimestamp = (timestamp) => timestamp ? user.dateTimeMinuteFormat.format(timestamp) : 'N/A';

    return (
        <>
            <Row justify={'space-between'} gutter={4}>
                <h2 className={'flex mediumGap'}>
                    <span>{test.name}</span>
                    <div className={'flexWrap extraSmallGap'}>
                        <Tag style={{lineHeight:'inherit'}} className="ch-tag-secondary">{test.testPurposeDescription}</Tag>
                        <Tag style={{lineHeight:'inherit'}} className="ch-tag-secondary">
                            {testResult.testAssignmentStatusDescription}
                        </Tag>
                    </div>
                </h2>
                {backButton && backButton}
            </Row>
            <Row gutter={4}>
                <Col>
                <Row className={'mediumGap'}>
                    <Col>
                        <Text strong>Teacher:</Text> <Text>{test.assignedBy ?? test.teacherName ?? 'N/A'}</Text>
                    </Col>
                    {test.startDate && (
                        <Col>
                            <Text strong>Assigned Date:</Text>{' '}
                            <Text>{formatTimestamp(test.startDate)}</Text>
                        </Col>
                    )}
                    {test.endDate && (
                        <Col>
                            <Text strong>Expiry Date:</Text>{' '}
                            <Text>{formatTimestamp(test.endDate)}</Text>
                        </Col>
                    )}
                </Row>
                {testResult &&
                    <Row>
                        <Col>
                            <Row gutter={8}>
                                <Col>
                                    <Text strong>Student:</Text>{' '}
                                    <Text>
                                        {testResult.firstName} {testResult.lastName}
                                    </Text>
                                </Col>
                                {testResult.startDate != undefined &&
                                    <Col>
                                        <Text strong>Started:</Text>{' '}
                                        <Text>{formatTimestamp(testResult.startDate)}</Text>
                                    </Col>
                                }
                                {testResult.completeDate != undefined && !testResult.open &&
                                    <Col>
                                        <Text strong>Completed:</Text>{' '}
                                        <Text>{formatTimestamp(testResult.completeDate)}</Text>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                }
                </Col>
                <Col style={{alignSelf:'center'}}>{printButton && printButton}</Col>
            </Row>
            <Divider size={'middle'}  />
            {testResult && <h3>{testResult.firstName} {testResult.lastName}</h3>}
            {!testResult.open &&
                <Row gutter={8}>
                    <Col>
                        <Text strong>Score:</Text>{' '}
                        <Text>
                            {testResult.mark ? testResult.mark : 0} / {testResult.maxMark}
                        </Text>
                    </Col>
                    <Col>
                        <Text strong>Percentage:</Text>{' '}
                        <Text>{testResult.percentCorrect}%</Text>
                    </Col>
                    <Col>
                        <Text strong>Total Questions:</Text>{' '}
                        <Text>{test.adaptive ? test.totalAdaptive : test.questionCount}</Text>
                    </Col>
                    <Col>
                        <Text strong>Total Answered:</Text>{' '}
                        <Text>{testResult.totalAnswered}</Text>
                    </Col>
                </Row>
            }
        </>
    );
};

TestHeader.propTypes = {
    test: PropTypes.shape({
        name: PropTypes.string.isRequired,
        testPurposeDescription: PropTypes.string,
        teacherName: PropTypes.string,
        startDate: PropTypes.number,
        endDate: PropTypes.number,
        questionCount: PropTypes.number.isRequired,
    }).isRequired,
    testResult: PropTypes.shape({
        testAssignmentStatusDescription: PropTypes.string,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        startDate: PropTypes.number,
        completeDate: PropTypes.number,
        mark: PropTypes.number,
        maxMark: PropTypes.number,
        percentCorrect: PropTypes.number,
    }).isRequired,
};

export default TestHeader;